import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { configService } from '../services/api';
import { USE_MOCK_DATA } from '../services/api';

const HeaderContainer = styled.header`
  background: var(--primary-color, #2c3e50);
  color: white;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 2rem;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

const UserInfo = styled.div`
  margin-right: 15px;
  font-size: 0.9rem;
`;

const LogoutButton = styled.button`
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #c0392b;
  }
`;

const Header = () => {
  const { user, logout } = useAuth();
  const [empresa, setEmpresa] = useState({
    nombre: USE_MOCK_DATA?'GeoClientes - Demo':'GeoClientes',
    logo_url: null,
    favicon_url: null,
    color_primario: '#2c3e50',
  });

  // Actualiza/crea la etiqueta <link rel="icon"> en el head
  const updateFavicon = (url) => {
    const id = 'app-favicon';
    let link = document.querySelector(`link#${id}`);
    if (!url) {
      if (link && link.parentNode) link.parentNode.removeChild(link);
      return;
    }
    if (!link) {
      link = document.createElement('link');
      link.id = id;
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (USE_MOCK_DATA) {
          // En modo mock, no consultar backend; usar valores por defecto y aplicar color
          const root = document.documentElement.style;
          if (empresa.color_primario) root.setProperty('--primary-color', empresa.color_primario);
          // En mock no hay favicon
          updateFavicon(null);
          return;
        }
        const cfg = await configService.getEmpresa();
        if (!mounted) return;
        setEmpresa(cfg);
        // Aplicar variables CSS globales
        const root = document.documentElement.style;
        if (cfg.color_primario) root.setProperty('--primary-color', cfg.color_primario);
        // Aplicar favicon dinámico
        updateFavicon(cfg.favicon_url);
      } catch (e) {
        // Silencioso: usar fallbacks iniciales
        // console.warn('No se pudo cargar configuración de empresa', e);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      // No necesitamos redirección aquí ya que PrivateRoute se encargará de esto
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <HeaderContainer>
      <LeftSection>
        <Logo>
          {empresa.logo_url ? (
            <img src={empresa.logo_url} alt="Logo" style={{ height: 28, width: 'auto' }} />
          ) : (
            '📍 LOGO'
          )}
        </Logo>
        <Title>{empresa.nombre || 'GeoClientes'}</Title>
      </LeftSection>
      
      {user && (
        <RightSection>
          <UserInfo>
            <span>Usuario: <strong>{user.name || user.email}</strong></span>
          </UserInfo>
          <LogoutButton onClick={handleLogout}>Cerrar sesión</LogoutButton>
        </RightSection>
      )}
    </HeaderContainer>
  );
};

export default Header;
